<div class="notification-message white-text mat-body-medium">
  <div class="notification-message_header">
    @if (data.type === 'success') {
      <i class="material-icons mat-icon-style">done</i>
    }
    @if (data.type === 'warning') {
      <i class="material-icons mat-icon-style">warning</i>
    }
    @if (data.type === 'danger') {
      <i class="material-icons mat-icon-style">error_outline</i>
    }
    <span class="custom-font">{{data.heading}}</span>
    <span class="notification-message_header-action">
      <a><i (click)="closeDialog()" class="material-icons svg-color">clear</i></a>
    </span>
  </div>
  <div class="notfication-body-padding">
    <span [innerHTML]="data.body"></span>
  </div>
</div>